import { useEffect, useMemo, useState } from "react";
import type { ProductTypeEntry } from "@/hooks/useOrgSettings";
import { useScopedOrganizationId } from "@/contexts/WorkspaceOrgContext";
import { listDealProductTypes, type OpsDealProductType } from "@/lib/opsDealTypesClient";
import { isFollowOnProductMetadata } from "@/lib/opsDealTypes/followOnProduct";
import { catalogFromDealTypes } from "@/lib/opsDealTypes/unionProductCatalog";

/**
 * Opportunity picker + Manager proposal rail: Ops Deal Types only.
 */
export function useDualReadProductTypes(): ProductTypeEntry[] {
  const orgId = useScopedOrganizationId();
  const [dealTypes, setDealTypes] = useState<OpsDealProductType[]>([]);

  useEffect(() => {
    let cancelled = false;
    setDealTypes([]);
    if (!orgId) return;
    void listDealProductTypes().then((res) => {
      if (cancelled) return;
      if (!res.ok) {
        setDealTypes([]);
        return;
      }
      setDealTypes(res.data.product_types ?? []);
    });
    return () => {
      cancelled = true;
    };
  }, [orgId]);

  return useMemo(
    () =>
      catalogFromDealTypes(
        dealTypes.map((d) => ({
          type_key: d.type_key,
          display_name: d.display_name,
          description: d.description,
          is_active: d.is_active,
          sort_order: d.sort_order,
          follow_on: isFollowOnProductMetadata(d.metadata),
        })),
      ),
    [dealTypes],
  );
}
